/*
Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.

Licensed under the Apache License, Version 2.0 (the "License").
You may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/
import { alpha, Paper } from '@mui/material';
import { styled } from '@mui/system';

export const PaperCard = styled(Paper)(({ theme }) => ({
  borderRadius: 16,
  bgcolor: alpha(theme.palette.background.paper, 0.95),
  boxShadow: `0 8px 32px ${alpha(theme.palette.common.black, 0.08)}`,
  padding: 20,
  display: 'flex',
  flexDirection: 'column',
}));
